import { AggregationAction, CollectionSchema, CollectionSchemaType } from '@next-space/fe-api-idl';
import { appI18n } from '@flowus/common/i18n';
import { getFormulaTool } from 'src/hooks/block/use-formula-tool';
import { getPropertySchema } from 'src/hooks/block/use-property-schema';

import { getRollupAggregation, MenuItems } from './helper';
import { getFooterAggregationActionCategoriesMenu } from './menu-helper';

export const getAvailableAggregations = (collectionId: string, propertyId: string) => {
  const { propertySchema, relationPropertySchema, targetPropertySchema } = getPropertySchema(
    collectionId,
    propertyId
  );

  if (!propertySchema) return [];
  const { type: propertySchemaType, targetProperty, aggregation } = propertySchema;

  const formulaTool = getFormulaTool(collectionId);

  let validAggregations: {
    type: AggregationAction | undefined;
    title: string;
  }[] = [];

  if (propertySchemaType === CollectionSchemaType.ROLLUP) {
    let targetPropertyType = targetPropertySchema?.type;

    if (targetPropertyType === CollectionSchemaType.FORMULA) {
      const relationFormulaTool = getFormulaTool(relationPropertySchema?.collectionId ?? '');

      targetPropertyType = relationFormulaTool.getTypeAsCollectionSchemaType(targetProperty ?? '');
    }
    if (!targetPropertyType) return [];

    validAggregations = getRollupAggregation(targetPropertyType, aggregation);
  } else if (propertySchemaType === CollectionSchemaType.FORMULA) {
    const schemaType = formulaTool.getTypeAsCollectionSchemaType(propertyId);
    validAggregations = MenuItems[schemaType] ?? [];
  } else {
    validAggregations = MenuItems[propertySchemaType] ?? [];
  }

  return [...validAggregations]; // 避免在 getRollupAggregations 中(引用)修改 MenuItems
};
export const getAvailableAggregationsForMenu = (collectionId: string, propertyId: string) => {
  const { propertySchema, relationPropertySchema, targetPropertySchema } = getPropertySchema(
    collectionId,
    propertyId
  );

  if (!propertySchema) return [];
  const { type: propertySchemaType, targetProperty } = propertySchema;
  const formulaTool = getFormulaTool(collectionId);

  let schemaType = propertySchemaType;
  if (propertySchemaType === CollectionSchemaType.ROLLUP) {
    let targetPropertyType = targetPropertySchema?.type;
    if (targetPropertyType === CollectionSchemaType.FORMULA) {
      const relationFormulaTool = getFormulaTool(relationPropertySchema?.collectionId ?? '');

      targetPropertyType = relationFormulaTool.getTypeAsCollectionSchemaType(targetProperty ?? '');
      schemaType = targetPropertyType;
    }
    if (!targetPropertyType) return [];
  } else if (propertySchemaType === CollectionSchemaType.FORMULA) {
    schemaType = formulaTool.getTypeAsCollectionSchemaType(propertyId);
  }
  const categories = getFooterAggregationActionCategoriesMenu(schemaType);
  return categories;
};

export const getRollupAggregations = (collectionId: string, propertyId: string, type?: string) => {
  const validAggregations = getAvailableAggregations(collectionId, propertyId);
  validAggregations.shift();

  if (type !== CollectionSchemaType.CHECKBOX) {
    validAggregations.unshift({
      type: AggregationAction.SHOW_UNIQUE,
      title: appI18n.t('common.show_unique'),
    });
  }

  validAggregations.unshift({
    type: AggregationAction.SHOW_ORIGIN,
    title: appI18n.t('common.show_origin'),
  });

  return validAggregations;
};
